module.exports = __webpack_public_path__ + "img/89ne.3b225bf8.svg";